import React from 'react';
import './About.css';
import Image from '../../assets/Images/avataaars.png';
import Resume from '../../assets/resume.pdf';
import AboutBox from './AboutBox';


const About = () => {
    const downloadResume = async () => {
        window.open(Resume, '_blank');
    }


    return (
        <section className="about container section" id="about">
            <h2 className="section__title">About Me </h2>

            <div className="about__container grid">
                <img src={Image} alt="" className='about__img' />
                {/* <Avatar
                    avatarStyle='Transparent'
                    topType='ShortHairShortRound'
                    accessoriesType='Prescription02'
                    hairColor='Black'
                    facialHairType='BeardLight'
                    facialHairColor='Black'
                    clotheType='Hoodie'
                    clotheColor='Blue02'
                    eyeType='Default'
                    eyebrowType='FlatNatural'
                    mouthType='Smile'
                    skinColor='Light'
                /> */}

                <div className="about__data grid">
                    <div className="about__info">
                        <p className="about__description">
                            👋 Hello! I'm Aness Zereg, and I'm based in Boumerdass, Algeria. I am currently pursuing my third year in Computer Science at the University M'Hamed Bougara of Boumerdes, where I continue to build my foundation in software development. 💻<br /><br />
                            🚀 Fast forward to today, and my journey has been filled with exciting challenges. As a Full Stack Developer specializing in web and mobile development, I'm constantly growing and expanding my skill set. These days, I’m focused on building impactful projects and being a proactive and collaborative team player. 🌟<br /><br />
                            🛠️ Here are a few technologies and tools I’ve been working with recently:
                        </p>
                        <ul className="about__list">
                            <li>⚡ JavaScript (ES6+)</li>
                            <li>🛠️ TypeScript</li>
                            <li>⚛️ React JS</li>
                            <li>⚛️ React Native</li>
                            <li>🔗 Node.js</li>
                            <li>🗄️ MongoDB</li>
                            <li>🎨 GSAP</li>
                            <li>🐘 PHP</li>
                            <li>🐍 Python</li>
                            <li>🌐 Laravel</li>
                            <li>🌿 Prisma</li>
                            <li>🗃️ Sequelize</li>
                            <li>💾 MySQL</li>
                            <li>📊 NoSQL</li>
                        </ul>
                        <button className="btn" onClick={downloadResume}> Download CV</button>
                    </div>



                    <div className="about__skills grid">
                        <div className="skills__data">
                            <div className="skills__titles">
                                <h3 className="skills__name">Development</h3>
                                <span className="skills__number">90%</span>
                            </div>

                            <div className="skills__bar">
                                <span className="skills__percentage development">

                                </span>
                            </div>
                        </div>

                        <div className="skills__data">
                            <div className="skills__titles">
                                <h3 className="skills__name">UI/UX Design</h3>
                                <span className="skills__number">80%</span>
                            </div>

                            <div className="skills__bar">
                                <span className="skills__percentage ui__design">

                                </span>
                            </div>
                        </div>

                        <div className="skills__data">
                            <div className="skills__titles">
                                <h3 className="skills__name">Photography</h3>
                                <span className="skills__number">60%</span>
                            </div>

                            <div className="skills__bar">
                                <span className="skills__percentage photography">

                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <AboutBox />
        </section>
    )
}

export default About